import { useMemo, useState } from 'react'
import { useGetAllMyInstructionsQuery } from '@/features/instructions/myInstructionsApi'
import { useDebouncedValue } from '@/lib/useDebouncedValue'
import { useRefreshOnFocus } from '@/lib/useRefreshOnFocus'

/**
 * Список статей для выбора в блок: те же данные, что в разделе инструкций
 * (`getAllMyInstructions` — все сразу, свежие сверху), только опубликованные
 * (`public`/`link`) и с поиском по названию. Общий для панели блока и холста.
 * Статью часто создают тут же, в соседней вкладке («Создать статью»): список
 * перечитывается на каждом открытии выбора и на возврате во вкладку студии.
 */
export const useArticlePickerList = (enabled = true) => {
  const [searchInput, setSearchInput] = useState('')
  const debouncedQ = useDebouncedValue(searchInput.trim())
  const { data, isLoading, isError, refetch } = useGetAllMyInstructionsQuery(undefined, {
    skip: !enabled,
    refetchOnMountOrArgChange: true,
  })
  useRefreshOnFocus(enabled, () => void refetch())
  const items = useMemo(() => {
    const needle = debouncedQ.toLowerCase()
    return (data ?? [])
      .filter((i) => i.accessType === 'public' || i.accessType === 'link')
      .filter((i) => !needle || i.title.toLowerCase().includes(needle))
      .sort((a, b) => b.id - a.id)
  }, [data, debouncedQ])
  return { searchInput, setSearchInput, debouncedQ, items, isLoading, isError }
}
